import PropTypes from "prop-types";

export const COMPONENT_SHAPE = {
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};

COMPONENT_SHAPE.components = PropTypes.arrayOf(
  PropTypes.shape(COMPONENT_SHAPE)
);
